// src/subscreens/admin/editCategory/EditCategory.jsx
//
// Context removed — parent se yeh props pass karo:
// <EditCategory isOpen onClose={...} category={categoryObject} onEdit={handleEdit} />

import axios from "axios";
import { useState, useEffect, useRef,useContext } from "react";
import AppContext from "../../../context/AppContext";
import Modal from "../../../components/admin/modal/ProductModel";
import { CheckCircle, UploadCloud, X } from "lucide-react";
import "../../../assets/css/admin/editCategory/EditCategory.css";

const EditCategory = ({ isOpen, onClose, category, onEdit }) => {
  const {baseUrl, authToken} = useContext(AppContext);
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState(null);
  const [errors, setErrors] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  // Populate form when category prop changes
  useEffect(() => {
    if (category) {
      setFormData({
        name: category.name || "",
        type: category.type || "",
        description: category.description || "",
        image: null,
        imagePreview: category.image || "",
      });
      setErrors({});
    }
  }, [category]);

  // ── Handlers ──
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      setErrors((prev) => ({
        ...prev,
        image: "Please select a valid image file.",
      }));
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      setErrors((prev) => ({
        ...prev,
        image: "Image must be smaller than 5 MB.",
      }));
      return;
    }

    const previewUrl = URL.createObjectURL(file);
    setFormData((prev) => ({ ...prev, image: file, imagePreview: previewUrl }));
    setErrors((prev) => ({ ...prev, image: "" }));
  };

  const handleRemoveImage = () => {
    if (formData.imagePreview?.startsWith("blob:"))
      URL.revokeObjectURL(formData.imagePreview);
    setFormData((prev) => ({ ...prev, image: null, imagePreview: "" }));
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const validate = () => {
    const errs = {};
    if (!formData.name.trim()) errs.name = "Category name is required.";
    if (!formData.type) errs.type = "Please select a category type.";
    if (!formData.description.trim())
      errs.description = "Description is required.";
    return errs;
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   const errs = validate();
  //   if (Object.keys(errs).length > 0) {
  //     setErrors(errs);
  //     return;
  //   }

  //   setIsSaving(true);
  //   setTimeout(() => {
  //     // ── To replace with API:
  //     // await fetch(`/api/categories/${category.id}`, { method: "PUT", body: JSON.stringify({...}) })
  //     onEdit({
  //       name: formData.name,
  //       type: formData.type,
  //       description: formData.description,
  //       image: formData.imagePreview || null,
  //     });
  //     setIsSaving(false);
  //     setShowSuccess(true);
  //     setTimeout(() => {
  //       setShowSuccess(false);
  //       onClose();
  //     }, 1500);
  //   }, 1000);
  // };
  const handleSubmit = (e) => {

  e.preventDefault();

  const errs = validate();

  if (Object.keys(errs).length > 0) {
    setErrors(errs);
    return;
  }

  setIsSaving(true);

  const formDataToSend = new FormData();

  formDataToSend.append("id", category.id);
  formDataToSend.append("name", formData.name);
  formDataToSend.append("type", formData.type);
  formDataToSend.append("description", formData.description);

  if(formData.image){
    formDataToSend.append("image", formData.image);
  }

  axios.post(
    `${baseUrl}/admin/category/updateCategory`,
    formDataToSend,
    {
      headers:{
        Authorization:`Bearer ${authToken}`,
        "Content-Type":"multipart/form-data"
      }
    }
  )
  .then((response)=>{

    console.log(response.data);

    setIsSaving(false);

    setShowSuccess(true);

    onEdit({
      ...category,
      id: category.id,
      name: formData.name,
      type: formData.type,
      description: formData.description,
      image: formData.imagePreview || category.image,
    });

    setTimeout(() => {
      setShowSuccess(false);
      onClose();
    }, 1500);

  })
  .catch((error)=>{

    console.log(error);

    setIsSaving(false);

  });
};

  const handleClose = () => {
    if (!isSaving) onClose();
  };

  // Guard — agar category load nahi hua
  if (!category || !formData) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Edit Category"
      size="medium"
    >
      {showSuccess ? (
        <div className="cat-edit-success-message">
          <div className="cat-edit-success-icon">
            <CheckCircle size={36} strokeWidth={1.8} />
          </div>
          <h3>Category Updated Successfully!</h3>
          <p>Your changes have been saved.</p>
        </div>
      ) : (
        <form className="cat-edit-form" onSubmit={handleSubmit}>
          <div className="cat-edit-form-grid">
            {/* ── Name ── */}
            <div className="cat-edit-form-group cat-edit-full-width">
              <label htmlFor="cat-edit-name">Category Name *</label>
              <input
                type="text"
                id="cat-edit-name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={errors.name ? "cat-edit-error" : ""}
                placeholder="e.g. Sofas, Dining Sets"
              />
              {errors.name && (
                <span className="cat-edit-error-text">{errors.name}</span>
              )}
            </div>

            {/* ── Type ── */}
            <div className="cat-edit-form-group cat-edit-full-width">
              <label>Category Type *</label>
              <div className="cat-edit-type-group">
                {["product", "inventory"].map((t) => (
                  <label
                    key={t}
                    className={`cat-edit-type-card ${formData.type === t ? "selected" : ""} ${errors.type ? "cat-edit-type-error" : ""}`}
                  >
                    <input
                      type="radio"
                      name="type"
                      value={t}
                      checked={formData.type === t}
                      onChange={handleChange}
                    />
                    <span className="cat-edit-type-label">
                      {t === "product" ? "Product" : "Inventory"}
                    </span>
                    <span className="cat-edit-type-sub">
                      {t === "product"
                        ? "For finished goods sold to customers"
                        : "For materials used in production"}
                    </span>
                  </label>
                ))}
              </div>
              {errors.type && (
                <span className="cat-edit-error-text">{errors.type}</span>
              )}
            </div>

            {/* ── Image ── */}
            <div className="cat-edit-form-group cat-edit-full-width">
              <label>Category Image</label>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="cat-edit-file-input"
                id="cat-edit-image-upload"
              />
              {formData.imagePreview ? (
                <div className="cat-edit-image-preview-wrap">
                  <img
                    src={formData.imagePreview}
                    alt="Preview"
                    className="cat-edit-image-preview"
                  />
                  <button
                    type="button"
                    className="cat-edit-image-remove"
                    onClick={handleRemoveImage}
                  >
                    <X size={14} />
                  </button>
                </div>
              ) : (
                <label
                  htmlFor="cat-edit-image-upload"
                  className={`cat-edit-upload-zone ${errors.image ? "cat-edit-error" : ""}`}
                >
                  <UploadCloud size={28} className="cat-edit-upload-icon" />
                  <span className="cat-edit-upload-text">
                    Click to upload image
                  </span>
                  <span className="cat-edit-upload-sub">
                    PNG, JPG, WEBP — max 5 MB
                  </span>
                </label>
              )}
              {errors.image && (
                <span className="cat-edit-error-text">{errors.image}</span>
              )}
            </div>

            {/* ── Description ── */}
            <div className="cat-edit-form-group cat-edit-full-width">
              <label htmlFor="cat-edit-description">Description *</label>
              <textarea
                id="cat-edit-description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                className={errors.description ? "cat-edit-error" : ""}
                placeholder="Briefly describe this category"
                rows="3"
              />
              {errors.description && (
                <span className="cat-edit-error-text">
                  {errors.description}
                </span>
              )}
            </div>
          </div>

          <div className="cat-edit-form-actions">
            <button
              type="button"
              className="cat-edit-cancel-btn"
              onClick={handleClose}
              disabled={isSaving}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="cat-edit-save-btn"
              disabled={isSaving}
            >
              {isSaving ? (
                <>
                  <span className="cat-edit-spinner" /> Saving…
                </>
              ) : (
                "Save Changes"
              )}
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default EditCategory;
